/**
 * All site translations.
 *
 * @type {object}
 */
export const translations = window.TRANSLATIONS;

/**
 * Translate a basic message from its original language to the current site
 * language.
 *
 * @param {string} originalMessage
 * @returns {string} Translated message
 */
export const translate = (originalMessage) =>
	translations[
		Object.keys(translations)
			.filter((key) => key === originalMessage)
			.shift()
	] || originalMessage;
